(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tr-materials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-tr-material] [data-finish]');
  if (!button) return;
  const area = button.closest('[data-tr-material]');
  area.querySelectorAll('[data-finish]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  area.querySelectorAll('[data-photo]').forEach(item => item.hidden = item.dataset.photo !== button.dataset.finish);
  area.querySelector('[data-material-tag]').textContent = button.dataset.tag;
  area.querySelector('[data-finish-description]').textContent = button.dataset.description;
  const link = area.querySelector('[data-finish-link]');
  link.href = button.dataset.link;
  link.textContent = button.dataset.label;
});

  } catch(e) { console.error(e); }
})();
})();
